import {Component, Input} from '@angular/core';
import {
  ApplicationFormSettings,
  CategoryItem,
  Competitor,
  CompetitorResults,
  EventItem,
  Lookups,
  Race,
  RaceSettings
} from '@model';
import {RaceService} from '@services';
import {AbstractComponent} from '@components';

@Component({
  selector: 'app-race-management-component',
  templateUrl: './race-management-component.component.html',
  styleUrls: ['./race-management-component.component.scss']
})
export class RaceManagementComponentComponent extends AbstractComponent {
  @Input() genders: Lookups[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Input() competitors: Competitor[] = [];
  @Input() results: CompetitorResults[] = [];
  @Input() race: Race | undefined;
  @Input() eventItem: EventItem | undefined;
  @Input() categories: CategoryItem[] = [];
  @Input() raceSettings: RaceSettings | undefined;
  @Input() applicationFormSettings: ApplicationFormSettings | undefined;

  constructor(public raceService: RaceService) {
    super();
  }
}
